"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["goals"],

  data: function data() {
    return {
      componentGoals: this.goals
    };
  },


  methods: {
    getGoalUpdateUrl: function getGoalUpdateUrl(goalId) {
      return "/goal/" + goalId;
    },
    deleteHealthGoal: function deleteHealthGoal(deletedGoalId) {
      this.componentGoals = this.componentGoals.filter(function (goal) {
        return goal.id !== deletedGoalId;
      });
      this.$emit("healthGoalsUpdate", this.componentGoals);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/dashboard/HealthGoals.vue
// module id = 4taZ
// module chunks = 1